const isGated = buzz => buzz?.tags?.includes('--gated-content-signin');

module.exports = {
  isGated
};
